import { SvgProps } from '../../model/types';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

const DownArrow = ({ size, onClick }: SvgProps) => {
  return (
    <svg
      {...stylex.props(styles.base, styles[size])}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13 9"
      data-testid="DownArrow"
      fill="none"
    >
      <path
        {...stylex.props(styles.base)}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.76517 8.14017C6.61872 8.28661 6.38128 8.28661 6.23484 8.14017L2.48484 4.39017C2.33839 4.24372 2.33839 4.00628 2.48484 3.85984C2.63128 3.71339 2.86872 3.71339 3.01516 3.85984L6.5 7.34467L9.98483 3.85984C10.1313 3.71339 10.3687 3.71339 10.5152 3.85984C10.6616 4.00628 10.6616 4.24372 10.5152 4.39017L6.76517 8.14017Z"
        fill="#1D252D"
      />
    </svg>
  );
};

export default DownArrow;
